import { render, staticRenderFns } from "./QuizDragAndDropPreview.vue?vue&type=template&id=9174ca82&"
import script from "./QuizDragAndDropPreview.vue?vue&type=script&lang=js&"
export * from "./QuizDragAndDropPreview.vue?vue&type=script&lang=js&"
import style0 from "./QuizDragAndDropPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports